// extracted by mini-css-extract-plugin
module.exports = {"title":"intro_title__liHjF","imageContainer":"intro_imageContainer__NQQDS","image":"intro_image__S_5vk"};